import { FC } from 'react';

import { UploadedFileIcon } from '../../../../assets/icons/index';
import { AppFormattedMessage } from '../../../../components/app-formatted-message/index';
import Button from '../../../../components/button/index';
import { openCompanyStorageUrlInNewTab } from '../../../../utils/company-storage-url.util';
import { getS3FileOriginalName } from '../../../../utils/get-s3file-original-name.util';

export type EventDocusignLinkedFilesSectionProps = {
  companyId: string;
  fileLinks: string[];
};

export const EventDocusignLinkedFilesSection: FC<EventDocusignLinkedFilesSectionProps> = ({
  companyId,
  fileLinks,
}) => {
  if (fileLinks.length === 0) return null;

  return (
    <div className="flex flex-col gap-2">
      <span className="text-xs font-[450] text-gray-500">
        <AppFormattedMessage id="LINKED_FROM_DOCUSIGN" />
      </span>
      {fileLinks.map((fileLink) => (
        <div
          className="flex items-center gap-2 overflow-hidden rounded border border-[#DDC0F9] bg-[#F0E5FA] p-3"
          key={fileLink}
        >
          <UploadedFileIcon iconColor="#6500CA" />
          <Button
            className="h-auto min-w-0 flex-1 cursor-pointer justify-start overflow-hidden p-0 text-left text-xs font-[450] text-gray-700"
            onClick={() => void openCompanyStorageUrlInNewTab(companyId, fileLink)}
            styleType="NONE"
            title={getS3FileOriginalName(fileLink)}
            type="button"
          >
            <span className="block w-full min-w-0 truncate">{getS3FileOriginalName(fileLink)}</span>
          </Button>
        </div>
      ))}
    </div>
  );
};
